import { useEffect } from "react";
import { useOpacity } from "../esri-components/OpacitySlider";
import useEsri from "../hooks/useEsri";
import {
  DEFAULT_POLLUTANT_METRIC_OPACITY,
  GIS_PM_LAYER_NAME,
} from "../settings";

const usePollutantMetricLayerOpacity = ({
  onPollutantMetricFieldChange,
  onZoneLaListFieldChange,
}) => {
  const { layerOpacity } = useEsri();
  const {
    opacityBtnStatus,
    opacityLayer,
    setOpacityBtnStatus,
    setOpacityLayer,
  } = useOpacity({
    DEFAULT_OPACITY: DEFAULT_POLLUTANT_METRIC_OPACITY,
  });
  useEffect(() => {
    if (!onZoneLaListFieldChange || !onPollutantMetricFieldChange) return;
    setOpacityLayer(0.5); //set pollutant metric layer opacity to 0 on area select field change
  }, [onZoneLaListFieldChange, onPollutantMetricFieldChange, setOpacityLayer]);

  useEffect(() => {
    if (typeof opacityLayer !== "number") return;
    layerOpacity(GIS_PM_LAYER_NAME, opacityLayer);
  }, [opacityLayer, layerOpacity]);

  const onOpacityChange = (value) => setOpacityLayer(value);

  return {
    onOpacityChange,
    opacityBtnStatus,
    opacityLayer,
    setOpacityBtnStatus,
  };
};

export default usePollutantMetricLayerOpacity;
